import React from "react";
import PropTypes from "prop-types";
import Datetime from "./react-datetime";
import "./index.css";
import Icon from "storybookComponents/Icon";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import moment from "moment";
import { makeStyles } from "@material-ui/core/styles";
import "moment-timezone";

const useStyles = makeStyles({
  underline: {
    "&:hover:not($disabled):not($focused):not($error):before": {
      borderBottom: "1px solid #26bbed !important",
    },
    "&:before": {
      borderBottom: "1px solid #dadada",
    },
    "&:after": {
      borderBottom: "1px solid #999999",
    },
  },
});

var yesterday = moment().subtract(1, "day");
var valid = function (current) {
  return current.isAfter(yesterday);
};

const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

const Picker = React.memo((props) => {
  const [value, setValue] = React.useState(props.defaultValue);
  React.useEffect(() => {
    setValue(props.defaultValue);
  }, [props.defaultValue]);

  const classes = useStyles();

  const parseData = (data) => {
    if (data.value === undefined) {
      data.value = "";
      return data;
    }
    let value = data.value;
    let dateTime = value.split(" ");
    if (dateTime.length === 3) {
      let date = dateTime[0].split("/");
      data.value =
        months[parseInt(dateTime[0]) - 1] +
        " " +
        date[1] +
        ", " +
        date[2] +
        " - " +
        dateTime[1] +
        " " +
        dateTime[2].toLowerCase() +
        (props.timezoneAbbr ? `, ${props.timezoneAbbr}` : "");
    } else if (dateTime.length === 1 && data.value) {
      let date = dateTime[0].split("/");
      data.value = months[parseInt(dateTime[0]) - 1] + " " + date[1] + ", " + date[2];
    }
    return data;
  };

  const { type, icon, format, ...rest } = props;

  const handleChange = (e) => {
    setValue(e);
    props.handleChange(e);
  };

  const moveUp = (e) => {
    if (props.moveUp && typeof props.moveUp == "function") {
      props.moveUp(e);
    }
    setTimeout(() => {
      window.scrollTo(0, document.body.scrollHeight);
    }, 500);
  };

  const customValidation = (current, _isSameOrAfter) => {
    var minValidDate = moment(props.minValidDate);
    if (_isSameOrAfter) {
      return current.isSameOrAfter(minValidDate);
    }
    return current.isAfter(moment(minValidDate).subtract(1, "day"));
  };
  return (
    <div
      style={{
        position: "absolute",
      }}
    >
      <Datetime
        showButton={props.showButton}
        dateFormat={type === "date" || type === "datetime"}
        timeFormat={type === "time" || type === "datetime"}
        onChange={handleChange}
        value={value}
        isValidDate={
          props.allowPast
            ? () => {
                return true;
              }
            : props.minValidDate
            ? customValidation
            : valid
        }
        displayTimeZone={props.timezoneString}
        alignCalendarPopup={props.alignCalendarPopup}
        minValidDate={props.minValidDate}
        renderInput={(data) => {
          return (
            <>
              {icon ? (
                <TextField
                  {...parseData(data)}
                  id="input-with-icon-textfield"
                  label={rest.placeholderText}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <Icon size="sm" type="icon-calendar-2" />
                      </InputAdornment>
                    ),
                    readOnly: true,
                    classes,
                  }}
                  {...rest}
                  underlineDisabled
                  autoComplete="off"
                  onFocus={moveUp}
                />
              ) : (
                <input
                  {...data}
                  type="text"
                  variant="top"
                  no_label={false}
                  required={false}
                  multiline={false}
                  readOnly
                  {...rest}
                  autoComplete="off"
                />
              )}
            </>
          );
        }}
      />
    </div>
  );
});

Picker.propTypes = {
  type: PropTypes.oneOf(["date", "time", "datetime", "timeframe"]).isRequired,
  handleChange: PropTypes.func,
};

Picker.defaultProps = {
  type: "date",
};

export default Picker;
